import { settings } from '../../../settings/settings-util'
import watch from 'redux-watch'
import cookies from 'browser-cookies'
import reducer from './reducers/index.js'
import * as Actions from './actions/actions.js'

export default class CookiePersistenceStrategy {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._cookieStorage = cookies;
    }

    static getDefaultSettings() {
        return settings;
    }

    getReducer() {
        return reducer;
    }

    initialize(store) {
        this._store = store;

        let stateLocations = this._settings.stateLocations;

        let persistWatcher = watch(this._store.getState, stateLocations.PersistentStorage.Base);

        this._store.subscribe(persistWatcher((newVal, oldVal, objectPath) => {
            return this.handlePersist(newVal);
        }));
    }

    async getPromise() {
        return new Promise((resolve) => {
            for(const cookieName in this._settings.Cookies){
                let cookieOptions = this._settings.Cookies[cookieName];

                let getOptions = cookieOptions.getOptions;

                if (typeof getOptions === "function") {
                    getOptions = getOptions();
                }

                let persistedState = JSON.parse(this._cookieStorage.get(cookieName, getOptions));

                this._store.dispatch(Actions.restorePersistedState(persistedState));
            }

            resolve();
            return;
        });
    }

    handlePersist(cookieInfo) {
        for(const cookieName in cookieInfo){
            let cookieOptions = this._settings.Cookies[cookieName];

            let setOptions = cookieOptions.setOptions;

            if (typeof setOptions === "function") {
                setOptions = setOptions();
            }
            if (Object.keys(this._settings.Cookies.domainMap).includes(window.location.hostname)) {
                setOptions.domain = this._settings.Cookies.domainMap[window.location.hostname];
            }

            this._cookieStorage.set(cookieName, JSON.stringify(cookieInfo[cookieName]), setOptions);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/persistence-strategy-cookie/src/persistence-strategy-cookie.js